import { all, call } from 'redux-saga/effects';
import { sagas as reboot } from './power/rebootModule';
import { sagas as reset } from './power/resetModule';
import { sagas as resize } from './resizeModule';
import { sagas as resizeVolume } from './resizeVolumeModule';
import { sagas as resizeStorage } from './resizeStorageModule';
import { sagas as start } from './startModule';
import { sagas as shutdown } from './shutdownModule';
import { sagas as update } from './updateModule';
import { sagas as availableFlavors } from './availableFlavorsModule';
import { sagas as availableStorage } from './availableStorageModule';
import { sagas as vncConsole } from './vncConsoleModule';
import { sagas as availableConfigs } from './availableConfigsModule';
import { sagas as history } from './historyModule';
import { sagas as destroy } from './destroyModule';
import auth from './auth/authSagas';
import whmSagas from './WHM/whmSagas';

export default function* serverSaga() {
	yield all([
		call(auth),
		call(availableStorage),
		call(availableConfigs),
		call(availableFlavors),
		call(availableStorage),
		call(destroy),
		call(history),
		call(reboot),
		call(reset),
		call(resize),
		call(resizeStorage),
		call(resizeVolume),
		call(shutdown),
		call(start),
		call(update),
		call(vncConsole),
		call(whmSagas),
	]);
}
